import { UserRole } from '@lmc/ts-common'
import { getKeys } from './getKeys'

export const teamTranslations = {
  [UserRole.careHomeAdmin]: 'Admin',
  [UserRole.carer]: 'Carer',
  [UserRole.family]: 'Family Member',
  [UserRole.groupAdmin]: 'Group Admin',
  [UserRole.groupManager]: 'Group Manager',
  [UserRole.it]: 'IT',
  [UserRole.lmcAdmin]: 'LMC Admin',
  [UserRole.seniorCarer]: 'Senior Carer',
  [UserRole.management]: 'Management',
  [UserRole.auditView]: 'Audit View',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  TEAM_MEMBERS_LIST: 'Team Members list',
  SAFEGUARDING_OFFICER: 'Safeguarding officer',
  SAFEGUARDING_OFFICER_NOTE:
    'Safeguarding logs may be raised by any staff member, but only those with Safeguarding permissions can access the information.',
  // CM-3382 wizard copy
  WIZARD_TITLE: 'Adding team member',
  WIZARD_STEP1_FIRST_NAME: 'First name',
  WIZARD_STEP1_FIRST_NAME_ERROR: 'Enter the team member’s first name.',
  WIZARD_STEP1_LAST_NAME: 'Last name',
  WIZARD_STEP1_LAST_NAME_ERROR: 'Enter team member’s last name.',
  WIZARD_STEP1_EMAIL: 'Email address',
  WIZARD_STEP1_EMAIL_HINT: 'This is where they’ll receive their login details.',
  WIZARD_STEP1_EMAIL_ERROR:
    'Enter an email address so we can send the invite and login details.',
  WIZARD_STEP1_EMAIL_INVALID_ERROR: 'Enter a valid email address.',
  WIZARD_STEP1_JOB_TITLE: 'Job title',
  WIZARD_STEP1_JOB_TITLE_ERROR: 'Enter team member’s job title.',
  WIZARD_STEP1_JOB_TITLE_HINT:
    'Choose a job title or type to create a new one.',
  // CM-3388: Site multi-select on the group screen’s "Add to specific sites" flow.
  WIZARD_STEP1_SITE: 'Site',
  WIZARD_STEP1_SITE_PLACEHOLDER: 'Select sites',
  WIZARD_STEP1_SITE_ERROR: 'Select at least one site.',
  // IT & Security: UI ships now per design's 6-role roster; backend
  // acceptance pending CM-2888. Keys are referenced from roleInfoCopy.ts
  // and Step2Role's role dropdown.
  ROLE_LABEL_IT_SECURITY: 'IT & Security',
  ROLE_PREVIEW_ITS_CO_BULLET1: 'Access to team member profiles',
  ROLE_PREVIEW_ITS_CO_BULLET2: 'Access to Device Access Control',
  ROLE_PREVIEW_ITS_CA_BULLET1: 'No access',
  WIZARD_STEP2_ROLE: 'Permission role',
  WIZARD_STEP2_ROLE_HINT:
    'This decides what they can view and do, not their job titles.',
  WIZARD_STEP2_ADMIN_DISABLED_TOOLTIP:
    'You don’t have permission to invite Admins.',
  WIZARD_STEP3_TITLE: 'Add-on capability',
  WIZARD_STEP3_HINT: 'Extra permissions for the selected role.',
  WIZARD_NEXT: 'Next',
  WIZARD_BACK: 'Back',
  WIZARD_SEND_INVITE: 'Send invite',
  WIZARD_INVITE_SENT_TOAST: 'Invite sent!',
  // CM-3383 Edit-permissions side panel
  EDIT_PANEL_TITLE: 'Editing permissions',
  EDIT_PANEL_CAPABILITIES_HEADING: 'Add-on capabilities',
  EDIT_PANEL_SAVED_TOAST: 'Permissions updated!',
  // CM-3452 Edit-permissions side panel — last-safeguarding-officer warning
  EDIT_PANEL_SAFEGUARDING_WARNING_TITLE_CAPABILITY:
    'Cannot remove Safeguarding Oversight.',
  EDIT_PANEL_SAFEGUARDING_WARNING_TITLE_ROLE: 'Role cannot be changed.',
  EDIT_PANEL_SAFEGUARDING_WARNING_INTRO:
    'This person is the last team member with this capability for:',
  EDIT_PANEL_SAFEGUARDING_WARNING_RESOLUTION:
    'Assign a replacement or disable safeguarding logs to continue.',
  // CM-3452 Privacy Officer block — temporary fallback until legacy
  // privacy-officer roles are migrated (reuses the role-change warning title).
  EDIT_PANEL_PRIVACY_OFFICER_WARNING_INTRO:
    'This person is a Privacy Officer for:',
  EDIT_PANEL_PRIVACY_OFFICER_WARNING_RESOLUTION:
    'Assign a replacement Privacy Officer before changing their role.',
  // CM-3665 Edit-profile redesign (single site)
  JOB_TITLE_HINT: 'Choose an existing job title or type to create a new one',
  SAFEGUARDING_MODAL_TITLE: 'Safeguarding Officer required',
  SAFEGUARDING_MODAL_CLOSE: 'Close',
  // CM-3388 Delete-account type-to-confirm modal
  DELETE_ACCOUNT_TITLE: 'Deleting account',
  DELETE_ACCOUNT_BODY: 'You’re about to delete <strong>{{name}}</strong>.',
  DELETE_ACCOUNT_BULLET_1:
    'The team member will no longer be able to log in to the Carer App or Care Office',
  DELETE_ACCOUNT_BULLET_2: 'This action cannot be undone',
  DELETE_ACCOUNT_BULLET_3: 'Their log history will remain visible',
  DELETE_ACCOUNT_CONFIRM_LABEL: 'To delete, type their name in full',
  DELETE_ACCOUNT_CTA: 'Delete',
  DELETE_ACCOUNT_DELETED_TOAST: 'Account deleted',
  // RoleInfoCard
  ROLE_PREVIEW_HEADING_PREFIX: 'What {{role}} can do',
  ROLE_PREVIEW_CARE_OFFICE: 'Care Office',
  ROLE_PREVIEW_CARER_APP: 'Carer App',
  // Capability toggle copy (label + bullets)
  CAPABILITY_SAFEGUARDING_OVERSIGHT_LABEL: 'Safeguarding Oversight',
  CAPABILITY_SAFEGUARDING_OVERSIGHT_BULLET1:
    'Manage safeguarding cases and access oversight reports',
  CAPABILITY_TEAM_MANAGEMENT_LABEL: 'Team Management',
  CAPABILITY_TEAM_MANAGEMENT_BULLET1: 'View team profiles and resend invites',
  CAPABILITY_TEAM_MANAGEMENT_BULLET2:
    'Manage team Training and Skills, Contract and Preferences, and Absences',
  CAPABILITY_TEAM_MANAGEMENT_BULLET3: 'Cannot add or delete team members',
  CAPABILITY_SERVICE_USER_MANAGEMENT_LABEL: '{{serviceUser}} Management',
  CAPABILITY_SERVICE_USER_MANAGEMENT_BULLET1:
    'Add and edit {{serviceUser}} profiles',
  CAPABILITY_SERVICE_USER_MANAGEMENT_BULLET_DOCUMENTATION:
    'Edit records in the Documentation section',
  CAPABILITY_SERVICE_USER_MANAGEMENT_BULLET_RISK: 'Archive Risk Assessments',
  CAPABILITY_SERVICE_USER_MANAGEMENT_BULLET2:
    'Cannot update sensitive information like DNACPR, {{serviceUser}} status',
  CAPABILITY_INCIDENT_MANAGEMENT_LABEL: 'Incident Management',
  CAPABILITY_INCIDENT_MANAGEMENT_BULLET1: 'Close incidents',
  CAPABILITY_DOWNLOAD_CENTRE_LABEL: 'Download Centre access',
  CAPABILITY_DOWNLOAD_CENTRE_BULLET1:
    'Access Download Centre to view and download care-related information',
  CAPABILITY_MEDICATION_MANAGEMENT_LABEL: 'Medication Management',
  CAPABILITY_MEDICATION_MANAGEMENT_BULLET1: 'Add medication in Care Office',
  CAPABILITY_TOGGLE_ON: 'On',
  CAPABILITY_TOGGLE_OFF: 'Off',
  // CM-3382 Phase A — RoleInfoCard bullet copy + footer link + Keyworker note
  ROLE_PREVIEW_OVERVIEW_LINK: 'See the overview of what each role can do',
  // careHomeAdmin (Admin)
  ROLE_PREVIEW_ADMIN_CO_BULLET1: 'Access all areas',
  ROLE_PREVIEW_ADMIN_CO_BULLET2: 'Full permissions',
  ROLE_PREVIEW_ADMIN_CA_BULLET1: 'Access all areas',
  ROLE_PREVIEW_ADMIN_CA_BULLET2: 'Full permissions',
  // management
  ROLE_PREVIEW_MGMT_CO_BULLET1: 'Access most areas',
  ROLE_PREVIEW_MGMT_CO_BULLET2:
    'Manage roles and permissions for all roles, except the Admin role',
  ROLE_PREVIEW_MGMT_CO_BULLET3:
    'Cannot access to Settings <settingsIcon></settingsIcon> and IT-related pages',
  ROLE_PREVIEW_MGMT_CO_BULLET4:
    'Cannot delete {{serviceUser}} and team member profiles',
  ROLE_PREVIEW_MGMT_CA_BULLET1: 'Access all areas',
  ROLE_PREVIEW_MGMT_CA_BULLET2: 'Full permissions',
  // seniorCarer
  ROLE_PREVIEW_SC_CO_BULLET1: 'Access most areas',
  ROLE_PREVIEW_SC_CO_BULLET2:
    'View-only to {{serviceUser}} profiles and body maps',
  ROLE_PREVIEW_SC_CO_BULLET3:
    'Cannot access to Settings <settingsIcon></settingsIcon>, Team, Training and Skills Matrix and Download Centre',
  ROLE_PREVIEW_SC_CO_BULLET4: 'Cannot delete Risk Assessments',
  ROLE_PREVIEW_SC_CO_BULLET5: 'Cannot update consent forms',
  ROLE_PREVIEW_SC_CO_BULLET6: 'Cannot close incidents',
  ROLE_PREVIEW_SC_CA_BULLET1: 'Access all areas',
  ROLE_PREVIEW_SC_CA_BULLET2: 'Full permissions',
  // carer
  ROLE_PREVIEW_CARER_CO_BULLET1: 'No access to Care Office',
  ROLE_PREVIEW_CARER_CA_BULLET1: 'Access all areas',
  ROLE_PREVIEW_CARER_CA_BULLET2: 'Cannot review care plans and goals',
  // carer Keyworker note (rendered after the Carer card's bullets)
  ROLE_PREVIEW_CARER_KEYWORKER_NOTE:
    'Note: Carers can review care plans and goals as a <bold>Keyworker</bold>. See <link>how to assign a carer</link>.',
  // auditView
  ROLE_PREVIEW_AV_CO_BULLET1: 'Access all areas, including Audit Trail',
  ROLE_PREVIEW_AV_CO_BULLET2: 'View-only permission',
  ROLE_PREVIEW_AV_CO_BULLET3:
    'Cannot access Settings <settingsIcon></settingsIcon> and Safeguarding logs',
  ROLE_PREVIEW_AV_CA_BULLET1: 'Access all areas',
  ROLE_PREVIEW_AV_CA_BULLET2: 'View-only permission',
  // CM-3422: Team list V2 surface (single-site). Group-only copy (site
  // access, group tabs, row actions) is localised with CM-3388/CM-3581.
  TEAM_LIST_TITLE: 'Team member list',
  TEAM_LIST_SUBTITLE: 'See an overview of all role types and access levels in',
  TEAM_LIST_OVERVIEW_LINK: 'Roles and Permissions overview',
  TEAM_LIST_ADD_MEMBER: 'Add member',
  TEAM_LIST_PERMISSION_ROLE: 'Permission role',
  TEAM_LIST_ADDON: 'Add-on',
  TEAM_LIST_EDIT_PERMISSIONS: 'Edit permissions',
  TEAM_LIST_SEE_PROFILE: 'See profile',
  TEAM_LIST_SEARCH_PLACEHOLDER: 'Search...',
  TEAM_LIST_SEARCH_ARIA: 'Search team members',
  TEAM_LIST_FILTERS: 'Filters',
  // CM-3581: Filters popover (single-site) + side panel (group dashboard).
  TEAM_LIST_FILTER_STATUS: 'Status',
  TEAM_LIST_FILTER_SITE: 'Site',
  TEAM_LIST_FILTER_APPLY: 'Apply filters',
  TEAM_LIST_FILTER_RESET: 'Reset filters',
  TEAM_LIST_FILTER_PANEL_TITLE: 'Applying filters',
  TEAM_LIST_TAB_ALL_MEMBERS: 'All members',
  TEAM_LIST_TAB_ADMIN: 'Admin',
  TEAM_LIST_TAB_MANAGEMENT: 'Management',
  TEAM_LIST_TAB_SENIOR_CARER: 'Senior Carer',
  TEAM_LIST_TAB_CARER: 'Carer',
  TEAM_LIST_TAB_IT_SECURITY: 'IT & Security',
  TEAM_LIST_TAB_AUDIT_VIEW: 'Audit View',
  TEAM_LIST_CHIP_SAFEGUARDING: 'Safeguarding',
  TEAM_LIST_CHIP_TEAM: 'Team',
  TEAM_LIST_CHIP_SERVICE_USER: 'Service User',
  TEAM_LIST_CHIP_INCIDENT: 'Incident',
  TEAM_LIST_CHIP_DOWNLOAD_CENTRE: 'Download Centre',
  TEAM_LIST_CHIP_MEDICATION: 'Medication',
  TEAM_LIST_SORT_RECENTLY_ADDED: 'Recently added',
  TEAM_LIST_SORT_FIRST_ADDED: 'First added',
  TEAM_LIST_SORT_FIRST_NAME_ASC: 'First Name (A → Z)',
  TEAM_LIST_SORT_FIRST_NAME_DESC: 'First Name (Z → A)',
  TEAM_LIST_SORT_ARIA: 'Sort by',
  TEAM_LIST_PAGINATION_LABEL: 'Pagination',
  TEAM_LIST_PAGINATION_PREV: 'Previous page',
  TEAM_LIST_PAGINATION_NEXT: 'Next page',
  TEAM_LIST_PAGINATION_PAGE: 'Page {{page}}',
  // CM-3388 Group Dashboard variant
  TEAM_LIST_TAB_GROUP_ADMIN: 'Group Admin',
  TEAM_LIST_TAB_GROUP_MANAGER: 'Group Manager',
  TEAM_LIST_ADD_TO_SPECIFIC_SITES: 'Add to specific sites',
  TEAM_LIST_ADD_TO_GROUP_DASHBOARD: 'Add to Group Dashboard',
  TEAM_LIST_ROW_ACTIONS_LABEL: 'More actions',
  TEAM_LIST_DELETE_ACCOUNT: 'Delete account',
  TEAM_LIST_SITE_ACCESS: 'Site access',
  TEAM_LIST_NO_SITE_ACCESS: 'No site access',
  TEAM_LIST_SITE_SHOW_LESS: 'Show less',
  TEAM_LIST_SITE_SHOW_MORE: 'Show {{count}} more',
  // CM-3452: tooltip shown on the disabled Edit permissions button when the
  // viewer has lower privilege than the target team member.
  TEAM_LIST_EDIT_PERMISSIONS_DISABLED_TOOLTIP:
    'You cannot edit a team member with a more senior role.'
}

export const reportsConstants = getKeys(teamTranslations)
